import "../../scss/pages/test-result-details.scss";

document.addEventListener("DOMContentLoaded", function () {
	import('bootstrap/js/dist/tooltip')
		.then(() => {
			$('.tooltip-button').tooltip({boundary: 'window'});
		})
		.catch((error) => {
			console.error("Error loading module:", error);
		});
});